import { api } from '../api/http'
import { ensurePlayableDeckList } from '../game/localDeck'
import { useAuthStore } from '../stores/auth'

/**
 * Vs-AI deck at match start. The server ignores a repeat of the same start.
 * Never throws.
 */
export function noteAiDeck(begunAt: number): void {
  try {
    const list = ensurePlayableDeckList()
    const token = useAuthStore().token
    if (!list || !token || !Number.isFinite(begunAt)) return
    void api('/analytics/deck', {
      method: 'POST',
      token,
      quiet: true,
      body: JSON.stringify({
        begunAt: Math.trunc(begunAt),
        main: list.main,
        extra: list.extra,
      }),
    }).catch(() => undefined)
  } catch {
    /* analytics must never break a duel */
  }
}
